import React, { useEffect, useState } from "react";
import useAccount from "classes/Accounts/hooks/useAccount";
import ScrollTable, { AsyncScrollTable } from "components/ScrollTable/ScrollTable";
import genRequest from "includes/request";
import { t } from "i18next";
import { useQuery } from "react-query";

export default function EmployeSelector({ selectedsUsers, setSelectedsUsers }) {
	const { account } = useAccount();
	const [selectedsSites, setSelectedsSites] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [selectedsFams, setSelectedsFams] = useState([]);
	const [selectedGroups, setSelectedGroups] = useState([]);
	const [users, setUsers] = useState([]);

	const getContactFiltered = async (page = 1, groups = []) => {
		setIsLoading(true);
		try {
			const result = await genRequest(`Employes/FilteredSortedContactEmployesWithGroup/`, {
				CompanyId: account.CompanyId,
				pageNumber: page,
				SearchedCategories: groups,
			}, "post");
			return result;
		} catch (error) {
			console.error('Erreur lors de la récupération des contacts:', error);
			throw error;
		} finally {
			setIsLoading(false);
		}
	};


	useEffect(() => {
		setUsers([]);
		setSelectedsUsers([]);
		setCurrentPage(1);
		setTotalPages(1);
		if (selectedGroups.length > 0) {
			const fetchInitialData = async () => {
				try {
					const result = await getContactFiltered(1, selectedGroups.map(group => group.GroupId));
					setUsers(result.Items);
					setCurrentPage(1);
					setTotalPages(result.TotalPages);
				} catch (error) {
					console.error('Erreur:', error);
				}
			};
			fetchInitialData();
		}
	}, [selectedGroups]);

	const handleGetNextItems = async () => {
		if (isLoading || currentPage >= totalPages) return;

		try {
			const nextPage = currentPage + 1;
			const result = await getContactFiltered(nextPage, selectedGroups.map(group => group.GroupId));

			setUsers(prevUsers => [...prevUsers, ...result.Items]);
			setCurrentPage(nextPage);
		} catch (error) {
			console.error('Erreur lors du chargement des éléments suivants:', error);
		}
	};

	// Calculer hasMore basé sur les données de pagination
	const hasMore = currentPage < totalPages && !isLoading;

	return (
		<div className="d-flex h-100">
			<AsyncScrollTable
				companyId={account.CompanyId}
				itemId={"SiteId"}
				queryKey={["Sites", "SitesOfCompany", account.CompanyId]}
				queryFn={() => genRequest("Sites/SitesOfCompany/" + account.CompanyId)}
				checkbox={true}
				className="light-bg"
				selected={selectedsSites}
				setSelected={setSelectedsSites}
				cols={[
					{
						name: "Name",
						title: t("User.SITE"),
						component: ({ item }) => (<div>{[item.Name, item.Town].filter(a => a).join(" - ")}</div>)
					}
				]}
				sortBy="Name"
			/>
			<AsyncScrollTable
				companyId={account.CompanyId}
				itemId={"GroupId"}
				queryKey={["Groups", "OfCompany", account.CompanyId]}
				queryFn={() => genRequest("Groups/OfCompany/" + account.CompanyId)}
				checkbox={true}
				className="light-bg"
				selected={selectedGroups}
				setSelected={setSelectedGroups}
				cols={[
					{
						name: "Name",
						title: t("User.GROUPS"),
						component: ({ item }) => (item.Name !== " " && <div>{item.Name}</div>)

					}
				]}
				sortBy="Name"
			/>

			<ScrollTable
				cols={[
					{
						name: "FirstName",
						title: t("User.USER"),
						component: ({ item }) => <div>{item.LastName} {item.FirstName}</div>
					}

				]}
				selected={selectedsUsers}
				setSelected={setSelectedsUsers}
				className="light-bg"
				checkbox={true}
				itemId={"EmployesId"}
				getNextItems={handleGetNextItems}
				hasMore={hasMore}
				items={users}
			/>
		</div>
	);
}
